import { render, staticRenderFns } from "./ExploreModuleLoader.vue?vue&type=template&id=50f36a61&scoped=true"
import script from "./ExploreModuleLoader.vue?vue&type=script&lang=ts"
export * from "./ExploreModuleLoader.vue?vue&type=script&lang=ts"
import style0 from "./ExploreModuleLoader.vue?vue&type=style&index=0&id=50f36a61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f36a61",
  null
  
)

export default component.exports